import React from 'react';
import './PostLoginLoader.css';

function PostLoginLoader({ message = 'Loading your dashboard…' }) {
  return (
    <div className="post-login-loader" role="alert" aria-live="assertive" aria-busy="true">
      <div className="post-login-loader-bg" aria-hidden="true">
        <span className="post-login-orb post-login-orb-1" />
        <span className="post-login-orb post-login-orb-2" />
        <span className="post-login-orb post-login-orb-3" />
        <span className="post-login-shimmer" />
      </div>

      <div className="post-login-loader-card">
        <div className="post-login-visual" aria-hidden="true">
          <span className="post-login-ring post-login-ring-outer" />
          <span className="post-login-ring post-login-ring-mid" />
          <span className="post-login-ring post-login-ring-inner" />
          <span className="post-login-logo-wrap">
            <img
              className="post-login-logo"
              src="/KeepMyAssetLogo.jpg"
              alt=""
              decoding="async"
            />
          </span>
        </div>

        <p className="post-login-brand">
          KeepMy<span className="post-login-brand-accent">Asset</span>
        </p>
        <p className="post-login-tagline">Peace of mind, secured.</p>

        <div className="post-login-status">
          <span className="post-login-status-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2L4 6v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V6l-8-4z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinejoin="round"
              />
              <path
                d="M9.5 12.2l1.8 1.8 3.5-3.6"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <p className="post-login-message">{message}</p>
        </div>

        <div className="post-login-progress" aria-hidden="true">
          <span className="post-login-progress-bar" />
        </div>

        <div className="post-login-dots" aria-hidden="true">
          <span className="post-login-dot" />
          <span className="post-login-dot" />
          <span className="post-login-dot" />
        </div>
      </div>
    </div>
  );
}

export default PostLoginLoader;
